// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__JELIP","iconTooltip":"styles_iconTooltip__WFKg7","required":"styles_required__aQ2ct"};